<template>
  <div>
    <b-modal :id="modalName" size="lg" hide-footer
             title="Détails de mon profil">
      <template v-if="ProfilDetailsState">
        <b-row>
          <b-col class="display-details-container">
            <b-row>
              <b-col>
                <list-show :list="list" :source="ProfilDetailsState"/>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </template>
      <close-btn-container :modal_name="modalName"></close-btn-container>
    </b-modal>
  </div>
</template>
<script>
  import closeBtnContainer from '~/components/popups/close-btn-container';
  import listShow from '~/components/template/form/list-show';
  export default {
    components: {
      closeBtnContainer,
      listShow
    },
    data() {
      return {
        list : [
          {title:'Code',attribut:'user_id'},
          {title:'Nom',attribut:'nom'},
          {title:'Prénom',attribut:'prenom'},
          {title:'Télephone',attribut:'telephone'},
          {title:'Rôle',attribut:'role'},
        ],
        modalName: 'profil-details'
      }
    },
    mounted() {
    },
    computed: {
      /**
       * @return {null}
       */
      ProfilDetailsState() {
        return this.$store.state.auth.profil;
      }
    },
    methods: {}
  }
</script>
<style scoped>
  .col{
    padding: 0 !important;
    padding-left: 13px !important;
  }
</style>
